import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaleEventDatePipe } from './custom-pipe/sale-event-date.pipe';
import { NextTabDirective } from './custom-directive/next-tab.directive';
import { SaleEventDateRangePipe } from './custom-pipe/sale-event-date-range.pipe';
import { PurpleEnvironmentIfComponent, PurpleEnvironmentNotIfComponent } from './purple-environment-if/purple-environment-if';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SaleEventDateRangePipe, SaleEventDatePipe, NextTabDirective, PurpleEnvironmentIfComponent, PurpleEnvironmentNotIfComponent],
  exports: [SaleEventDatePipe, SaleEventDateRangePipe, NextTabDirective, PurpleEnvironmentIfComponent, PurpleEnvironmentNotIfComponent]
})
export class PurpleProjectWidgetsModule { }
